/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@ngx-translate/core/src/translate.pipe';
import * as i2 from '@ngx-translate/core/src/translate.service';
import * as i3 from '@angular/common';
import * as i4 from '@angular/router';
import * as i5 from '../../app/app.component';
import * as i6 from '../../app/global.state';
import * as i7 from '../../app/theme/services/baThemeSpinner/baThemeSpinner.service';
import * as i8 from '../../app/modules/employee/service/user-idle/user-idle.service';
import * as i9 from '../../app/modules/employee/service/login/login.service';
const styles_AppComponent:any[] = ([] as any[]);
export const RenderType_AppComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,styles:styles_AppComponent,
    data:{}});
function View_AppComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),5,'div',[['class',
      'ribbon-wrapper-red']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵeld(2,
      0,(null as any),(null as any),2,'div',[['class','ribbon-red']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted(3,
      (null as any),['',''])),i0.ɵpid(131072,i1.TranslatePipe,[i2.TranslateService,
      i0.ChangeDetectorRef]),(_l()(),i0.ɵted(-1,(null as any),['\n  ']))],(null as any),
      (_ck,_v) => {
        const currVal_0:any = i0.ɵunv(_v,3,0,i0.ɵnov(_v,4).transform('testing'));
        _ck(_v,3,0,currVal_0);
      });
}
export function View_AppComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),11,'main',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),i0.ɵdid(1,
      278528,(null as any),0,i3.NgClass,[i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,
          i0.Renderer],{ngClass:[0,'ngClass']},(null as any)),i0.ɵpod(2,{'menu-collapsed':0}),
      (_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_AppComponent_1)),i0.ɵdid(5,16384,(null as any),
          0,i3.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵeld(7,0,(null as any),
          (null as any),0,'div',[['class','additional-bg']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),
          ['\n  '])),(_l()(),i0.ɵeld(9,16777216,(null as any),(null as any),1,'router-outlet',
          ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i0.ɵdid(10,212992,(null as any),0,i4.RouterOutlet,[i4.ChildrenOutletContexts,
          i0.ViewContainerRef,i0.ComponentFactoryResolver,[8,(null as any)],i0.ChangeDetectorRef],
          (null as any),(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n'])),(_l()(),
          i0.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i5.AppComponent = _v.component;
    const currVal_0:any = _ck(_v,2,0,_co.isMenuCollapsed);
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = (_co.testing == 'true');
    _ck(_v,5,0,currVal_1);
    _ck(_v,10,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'app-root',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i0.ɵdid(1,4308992,(null as any),0,i5.AppComponent,[i6.GlobalState,i7.BaThemeSpinner,
          i8.UserIdleService,i9.LoginService,i4.Router],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const AppComponentNgFactory:i0.ComponentFactory<i5.AppComponent> = i0.ɵccf('app-root',
    i5.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL2FwcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMiLCJuZzovLy9EOi9pbmV0cHViL3d3d3Jvb3Qva2FpemVuLW5nL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPG1haW4gW25nQ2xhc3NdPVwieydtZW51LWNvbGxhcHNlZCc6IGlzTWVudUNvbGxhcHNlZH1cIj5cclxuICA8ZGl2IGNsYXNzPVwicmliYm9uLXdyYXBwZXItcmVkXCIgKm5nSWY9XCJ0ZXN0aW5nPT0ndHJ1ZSdcIj5cclxuICAgIDxkaXYgY2xhc3M9XCJyaWJib24tcmVkXCI+e3sndGVzdGluZycgfCB0cmFuc2xhdGV9fTwvZGl2PlxyXG4gIDwvZGl2PlxyXG4gIDxkaXYgY2xhc3M9XCJhZGRpdGlvbmFsLWJnXCI+PC9kaXY+XHJcbiAgPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PlxyXG48L21haW4+XHJcbiIsIjxhcHAtcm9vdD48L2FwcC1yb290PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQ0U7TUFBQTtNQUFBLGdCQUF3RCw4Q0FDdEQ7TUFBQTtNQUFBLDBEQUF3QjtNQUFBOzBCQUFBLEdBQStCOztRQUEvQjtRQUFBOzs7O29CQUY1QjtNQUFBLCtFQUFBO01BQUE7cUJBQUEsZ0RBQU07TUFBZ0QsNENBQ3BEO1VBQUEsMkRBQUE7VUFBQTtNQUVNLDRDQUNOO1VBQUE7VUFBQSw0Q0FBaUM7VUFBQSxXQUNqQztVQUFBO2FBQUE7MERBQUE7VUFBQSw2QkFBK0IsMENBQzFCO2lCQUFBOztJQU5EO0lBQU4sV0FBTSxTQUFOO0lBQ2tDO0lBQWhDLFdBQWdDLFNBQWhDO0lBSUE7Ozs7b0JDTEY7TUFBQTthQUFBO3NEQUFBOztRQUFBOzs7OyJ9



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/app.component.ngfactory.ts